<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutRequestingSpinner.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutRequestingSpinner.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div v-if="show" data-ref="checkout-requesting-spinner">
        <div class="spinner_overlay">
            <div class="spinner_overlay--center d-flex justify-content-center  align-items-center">
                <div class="d-flex justify-content-center align-items-center bg-warning p-3 z-depth-3 text-dark"><i
                        class="material-icons warning-icon mr-2">warning</i>
                    <div class="p-2">
                        <h3 class="p-0" v-if="width >= 80">Requesting card payment</h3>
                        <h3 class="p-0" v-else>Validating Card</h3>
                        <div>Do not refresh or hit the back button</div>
                        <div class="progress">
                            <div id="requesting-response--spinner"
                                 class="progress-bar progress-bar-striped progress-bar-animated"
                                 role="progressbar"
                                 aria-valuenow="0"
                                 aria-valuemin="0"
                                 aria-valuemax="100"
                                 :style="{
                            width:width + '%'
                         }"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckoutRequestingSpinner",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            width:{
                type: Number,
                default: 0
            },
            stage:{
                type: Number,
                default: 1
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutRequestingSpinner.vue